var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.632 1.73909L25.0153 12.1487C25.1273 12.493 25.3454 12.793 25.6385 13.0057C25.9315 13.2184 26.2844 13.3329 26.6465 13.3327H37.6001C39.2617 13.3327 39.952 15.4591 38.6081 16.4351L29.7465 22.8703C29.4528 23.0832 29.2343 23.3838 29.1223 23.7288C29.0103 24.0739 29.0107 24.4455 29.1233 24.7903L32.5064 35.1967C33.0201 36.7767 31.2113 38.0903 29.8664 37.1167L21.0089 30.6759C20.716 30.463 20.3633 30.3483 20.0013 30.3483C19.6392 30.3483 19.2865 30.463 18.9937 30.6759L10.1321 37.1119C8.78805 38.0879 6.98005 36.7743 7.49205 35.1919L10.8801 24.7871C10.9926 24.4423 10.993 24.0706 10.881 23.7256C10.769 23.3806 10.5505 23.08 10.2569 22.8671L1.39525 16.4351C0.0512521 15.4591 0.741652 13.3327 2.40005 13.3327H13.3601C13.722 13.3327 14.0747 13.2182 14.3676 13.0055C14.6604 12.7928 14.8785 12.4929 14.9905 12.1487L18.3745 1.73909C18.8841 0.159888 21.1201 0.159888 21.632 1.73909Z",
    fill: "#F9C654"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullStar);
export default __webpack_public_path__ + "static/media/FullStar.4285581c.svg";
export { ForwardRef as ReactComponent };